// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button{border:none}.wrap-ErS1v{padding:60px 20px;display:flex;justify-content:center}.fullWidth-zk7Wp .content-3-xTi{flex:1}.content-3-xTi{max-width:1200px;display:flex;flex-direction:column;gap:20px}@media(max-width: 920px){.mobileFullWidth-Bcp6i{padding:40px 0 0}.mobileFullWidth-Bcp6i .content-3-xTi{flex:1}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "wrap-ErS1v",
	"fullWidth": "fullWidth-zk7Wp",
	"content": "content-3-xTi",
	"mobileFullWidth": "mobileFullWidth-Bcp6i"
};
export default ___CSS_LOADER_EXPORT___;
